import { Component, ChangeDetectionStrategy, forwardRef, AfterContentInit, Injector, input, OnDestroy } from '@angular/core';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { FormControl, NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule } from '@angular/forms';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-form-date',
  templateUrl: './form-date.component.html',
  styleUrls: ['./form-date.component.scss', '../form.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatDatepickerModule
],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDateComponent),
      multi: true,
    },
  ],
})
export class FormDateComponent extends BaseControlValueAccessor<string | null> implements AfterContentInit {
  label = input<string>('');
  control!: FormControl;
  valueChangesSub!: Subscription;
  constructor(private injector: Injector) {
    super();
  }
  ngAfterContentInit(): void {
    const ngControl: NgControl = this.injector.get(NgControl, null) as NgControl;
    if (ngControl) {
      this.control = ngControl.control as FormControl;
    } else {
      this.control = new FormControl();
    }
  }

  // Override writeValue to handle incoming values
  override writeValue(value: any): void {
    let dateValue: Date | null = null;
    if (value) {
      if (value instanceof Date) {
        dateValue = new Date(value.getFullYear(), value.getMonth(), value.getDate());
      } else if (typeof value === 'string') {
        const [year, month, day] = value.split('-').map(Number);
        dateValue = new Date(year, month - 1, day);
        if (isNaN(dateValue.getTime())) {
          dateValue = null;
        }
      }
    }
    // Set the value with emitEvent: true to trigger valueChanges
    if (!this.isSameDate(this.control?.value, dateValue)) {
      this.control?.setValue(dateValue, { emitEvent: true });
    } else if (dateValue && !isNaN(dateValue.getTime())) {
    } else {
      this.onChange(null);
    }
  }

  private isSameDate(date1: any, date2: any): boolean {
    if (date1 === date2) {
      return true;
    }
    if (!date1 || !date2) {
      return false;
    }
    if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
      return false;
    }
    const isSame = (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
    return isSame;
  }
}